import { useNavigate, useLocation } from "react-router-dom";

const sidebarLinks = [
    { path: "/account", label: "Profile", icon: "👤" },
    { path: "/orders", label: "My Orders", icon: "📦" },
    { path: "/addresses", label: "Addresses", icon: "📍" },
    // { path: "/wishlist", label: "Wishlist", icon: "❤️" },
];

export function AccountSidebar({ user, onLogout }) {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="account-sidebar" style={{
            background: "white", borderRadius: 22,
            border: "1.5px solid #f0d0c8",
            padding: 28, position: "sticky", top: 84,
            boxShadow: "0 4px 18px rgba(192,57,43,0.07)",
            overflow: "hidden"
        }}>
            <style>{`
                @media (max-width: 991px) {
                    .account-sidebar { 
                        position: sticky !important; 
                        top: 70px !important; 
                        z-index: 100 !important;
                        padding: 16px !important; 
                        margin-bottom: 24px !important;
                        border-radius: 0 0 16px 16px !important;
                        border-top: none !important;
                        margin-left: -16px !important;
                        margin-right: -16px !important;
                        width: calc(100% + 32px) !important;
                    }
                    .account-sidebar-user { 
                        display: none !important; 
                    }
                    .account-nav-list { 
                        flex-direction: row !important; 
                        overflow-x: auto !important; 
                        padding-bottom: 4px !important;
                        -webkit-overflow-scrolling: touch;
                        gap: 8px !important;
                        scroll-snap-type: x mandatory;
                        scrollbar-width: none;
                    }
                    .account-nav-list::-webkit-scrollbar { display: none; }
                    
                    .account-nav-btn {
                        white-space: nowrap !important;
                        width: auto !important;
                        flex-shrink: 0 !important;
                        padding: 10px 14px !important;
                        scroll-snap-align: start;
                    }
                    .sidebar-divider.crimson-line { 
                        margin: -16px -16px 16px !important; 
                    }
                    .sidebar-divider:not(.crimson-line) { display: none !important; }
                    .logout-btn { 
                        width: auto !important; 
                        margin-left: auto !important;
                        flex-shrink: 0 !important;
                        padding: 10px 14px !important;
                    }
                }
            `}</style>
            {/* Top crimson bar */}
            <div className="sidebar-divider crimson-line" style={{ height: 3, background: "linear-gradient(90deg, #C0392B, #E8523A)", margin: "-28px -28px 24px" }} />

            {/* User info */}
            <div className="account-sidebar-user" style={{ textAlign: "center", marginBottom: 24, paddingBottom: 24, borderBottom: "1.5px solid #f0d0c8" }}>
                <div style={{
                    width: 64, height: 64, borderRadius: "50%",
                    background: "linear-gradient(135deg, #C0392B, #96221A)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    margin: "0 auto 12px", fontSize: 24, color: "white",
                    fontFamily: "'Playfair Display',serif", fontWeight: 800,
                    boxShadow: "0 4px 16px rgba(192,57,43,0.35)"
                }}>
                    {(user?.name || "U")[0].toUpperCase()}
                </div>
                <div style={{ fontFamily: "'Playfair Display',serif", fontWeight: 700, fontSize: 16, color: "#1a0a08" }}>
                    {user?.name || "User"}
                </div>
                <div style={{ fontSize: 12, color: "#b07878", marginTop: 2 }}>{user?.email || ""}</div>
            </div>

            {/* Nav links */}
            <div className="account-nav-list" style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                {sidebarLinks.map(link => {
                    const active = location.pathname === link.path;
                    return (
                        <button
                            key={link.path}
                            className="account-nav-btn"
                            id={`nav-btn-${link.label.toLowerCase()}`}
                            onClick={() => { navigate(link.path); window.scrollTo(0, 0); }}
                            style={{
                                display: "flex", alignItems: "center", gap: 12,
                                padding: "12px 16px", borderRadius: 12, border: "none",
                                background: active ? "#fff0f0" : "transparent",
                                cursor: "pointer", transition: "all 0.15s",
                                fontFamily: "'Nunito Sans',sans-serif", fontSize: 14,
                                fontWeight: active ? 700 : 500,
                                color: active ? "#C0392B" : "#7a5550",
                                textAlign: "left", width: "100%",
                                borderLeft: active ? "3px solid #C0392B" : "3px solid transparent"
                            }}
                            onMouseEnter={e => { if (!active) { e.currentTarget.style.background = "#fff8f8"; e.currentTarget.style.color = "#C0392B"; } }}
                            onMouseLeave={e => { if (!active) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#7a5550"; } }}
                        >
                            <span style={{ fontSize: 17 }}>{link.icon}</span>
                            {link.label}
                        </button>
                    );
                })}

                {/* Divider */}
                <div className="sidebar-divider" style={{ height: "1px", background: "#f0d0c8", margin: "8px 0" }} />

                <button
                    className="logout-btn"
                    onClick={() => { onLogout(); navigate("/"); window.scrollTo(0, 0); }}
                    style={{
                        display: "flex", alignItems: "center", gap: 12,
                        padding: "12px 16px", borderRadius: 12, border: "none",
                        background: "transparent", cursor: "pointer", transition: "all 0.15s",
                        fontFamily: "'Nunito Sans',sans-serif", fontSize: 14, fontWeight: 500,
                        color: "#C0392B", textAlign: "left", width: "100%"
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = "#fff0f0"; }}
                    onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
                >
                    <span style={{ fontSize: 17 }}>🚪</span>
                    Logout
                </button>
            </div>
        </div>
    );
}

export function AccountLayout({ user, onLogout, children }) {
    return (
        <div className="account-layout-main" style={{ minHeight: "100vh", background: "#FDF5F5", padding: "40px 72px" }}>
            <style>{`
                @media (max-width: 991px) {
                    .account-layout-main { padding: 0 16px 24px !important; }
                    .account-layout-grid { 
                        grid-template-columns: 1fr !important; 
                        gap: 16px !important; 
                    }
                }
            `}</style>
            <div className="account-layout-grid" style={{ display: "grid", gridTemplateColumns: "260px 1fr", gap: 32, maxWidth: 1100, margin: "0 auto" }}>
                <AccountSidebar user={user} onLogout={onLogout} />
                <div className="account-content">{children}</div>
            </div>
        </div>
    );
}
